<template>
	<section id="nomination_page">
	
	<h3 class="section_title">Nominations</h3>
	
	<div class="container">
		<div class="row justify-content-center">
			<div class="col-12 col-lg-10">
				
				<!-- EVENT NOT STARTED -->
				<intro-not-started
				v-if="instance_period == 'Event not started'"
				:nom_start_date="nom_period_data.start"
				:tz_offset="timezone_offset"
				></intro-not-started>

				<!-- NOMINATION PERIOD -->
				<intro-nomination-period
				v-if="instance_period == 'Nomination Period'"
				:nom_stop_date="nom_period_data.stop"
				:tz_offset="timezone_offset"
				></intro-nomination-period>

				<!-- VOTING HAS NOT ENDED -->
				<intro-voting-not-ended
				v-if="instance_period == 'Nomination Intermission' || instance_period == 'Voting Period'"
				:nom_start_date="nom_period_data.start"
				:tz_offset="timezone_offset"
				></intro-voting-not-ended>

				<!-- VOTING INTERMISSION -->
				<intro-voting-intermission
				v-if="instance_period == 'Voting Intermission'"
				:nom_start_date="nom_period_data.start"
				:tz_offset="timezone_offset"
				></intro-voting-intermission>

				<!-- WINNERS PERIOD AND BEYOND -->
				<intro-winners-period
				v-if="instance_period == 'Winners Period' || instance_period == 'Event has ended'"
				:nom_start_date="nom_period_data.start"
				:tz_offset="timezone_offset"
				></intro-winners-period>

				<div class="stories_toggle"
				v-if="instance_period != 'Nomination Period'"
				>
					<h4>
						Here's some other great stuff from Dayton.com:
					</h4>
					<dcom-latest-stories-list></dcom-latest-stories-list>
				</div>

			</div>
		</div>
	</div>

	<div class="login_category_container"
	v-if="instance_period == 'Nomination Period'"
	>
		<trans-bounce>

			<!-- LOGIN PROMPT FOR NON-LOGGED-IN USERS -->
			<login-prompt
			v-if="!is_logged_in"
			></login-prompt>

			<!-- SUPER CATEGORY LIST -->
			<super-category-list
			v-else
			list_type="nominations"
			></super-category-list>

		</trans-bounce>
	</div>

	</section>
</template>

<script>
import SuperCategoryList from '@/features/category/super_category_contest_list.vue';
import LoginPrompt from '@/features/login/login_prompt.vue';
import Countdown from '@/features/countdown/countdown_timer.vue';
import IntroNotStarted from '@/features/nominate/intros/nom_intro_event_not_started.vue'
import IntroNominationPeriod from '@/features/nominate/intros/nom_intro_nomination_period.vue'
import IntroVotingNotEnded from '@/features/nominate/intros/nom_intro_voting_not_ended.vue'
import IntroVotingIntermission from '@/features/nominate/intros/nom_intro_voting_intermission.vue'
import IntroWinnersPeriod from '@/features/nominate/intros/nom_intro_winners_period.vue'
import TransBounce from '@/components/transitions/trans_bounce_inL_outR.vue';
import DcomLatestStoriesList from '@/features/cms_content/dcom_latest_stories_list'
import { library } from '@fortawesome/fontawesome-svg-core';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
library.add(faSearch);

export default {
	name: 'NominationPage',
	data () {
		return {

		}
	},
	mounted() {
		document.dispatchEvent(new Event('prerender-trigger'));
		this.determine_chartbeat();
	},
	beforeUpdate() {
		// this.$root.store.nominations.change_single_nom_share_status(false);
	},
	computed: {
		instance_period: {
			get: function() {
				return this.$root.store.instances.get_current_active_instance_period();
			}
		},
		timezone_offset: function() {
			return this.$root.store.instances.get_current_timezone_offset();
		},
		nom_period_data: function() {
			return this.$root.store.instances.get_specific_instance_period('Nomination Period');
		},
		is_logged_in: function() {
			return this.$root.store.session.check_login_status();
		},
		user_data: function() {
			return this.$root.store.session.get_user_email();
		},
		nom_share_status: function() {
			return this.$root.store.nominations.get_current_nom_share_status();
		}
	},
	methods: {
		change_period: function(new_period) {
			this.instance_period = new_period;
		},
		run_chartbeat: function() {
			window.updateChartbeat(document.title, window.location.pathname);
		},
		determine_chartbeat: function() {
			let vm = this;
			let page_title = document.title;

			if(page_title.indexOf(vm.$metaInfo.title) == 0) {
				vm.run_chartbeat();
			}
			else {
				setTimeout(function() {
					vm.determine_chartbeat();
				}, 500);
			}
		}
	},
	metaInfo() {
		return {
			title: 'Nominations',
			titleTemplate: '%s | Best of Dayton 2019',
			meta: [
				{
					name: 'description',
					vmid: 'description',
					content: 'Nominate your favorite local businesses, food, service providers, and more!'
				},
				{
					property: 'og:title',
					content: 'Nominate for Best of Dayton 2019'
				},
				{
					property: 'og:site_name',
					content: 'Best of Dayton 2019'
				},
				{
					property: 'og:type',
					content: 'website'
				},
				{
					property: 'og:description',
					content: 'Nominate your favorite local businesses, food, service providers, and more!'
				},
				{
					property: 'og:image',
					content: 'https://www.dayton.com/rf/image_large/Pub/p10/Dayton/2019/11/08/Images/DDC_BestofDayton_LeadRelatedObject_169.jpg?v=2019'
				}
			]
		}
	},
	components: {
		SuperCategoryList,
		LoginPrompt,
		IntroNotStarted,
		IntroNominationPeriod,
		IntroVotingNotEnded,
		IntroVotingIntermission,
		IntroWinnersPeriod,
		Countdown,
		TransBounce,
		DcomLatestStoriesList
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">

#nomination_page {

}
</style>


// WEBPACK FOOTER //
// src/pages/NominationPage.vue